App.directive('toggleMenuMobile', function() { 
    return {
        restrict: 'A',
        scope: {
            
        },
        link: function(scope, elm) {
            $(elm[0]).on('click', function() {
                var w = -$('.menu_mobile').innerWidth();

                if (!$('.menu_mobile').hasClass('open')) {
                    $('.menu_mobile').addClass('open');
                    $('.menu_mobile').velocity("stop", true).velocity({right: 0});
                } else {
                    $('.menu_mobile').removeClass('open');
                    $('.menu_mobile').velocity("stop", true).velocity({right: w});
                }
            });
        }
    }
});